








































import CertCard from '@/components/card/CertCard.vue'
import EmptyMessage from '@/components/EmptyMessage.vue'
import FooterLayout from '@/components/Footer.vue'
import HeaderLayout from '@/components/Header.vue'
import MainLayout from '@/layouts/default/MainLayout.vue'
import Translation from '@/mixins/Translation'
import {namespace} from 'vuex-class'
import {LogEventWidthGroupsPayload} from '@/store/modules/gtm/types'
import {Component, Mixins, Prop} from 'vue-property-decorator'
import WorkflowHandler from '@/components/WorkflowHandler.vue'
import FooterButton from '@/components/FooterButton.vue'

const institutions = namespace('institutions')
const layout = namespace('layout')
const biz = namespace('biz')
const workflows = namespace('workflows')
const gtm = namespace('gtm')

const enablingInstitutionWorkflowCodes = {
  'bank': 'enabling_specific_bank',
  'giro': 'enabling_giro',
  'hometax': 'enabling_hometax',
  'ei': 'enabling_ei',
}

@Component({
  components: {FooterButton, MainLayout, WorkflowHandler, CertCard, EmptyMessage, FooterLayout, HeaderLayout},
})
export default class CertFailedReasonPage extends Mixins(Translation) {
  @Prop({default: '', type: String}) name: string
  @Prop({default: 0, type: Number}) windowScrollY: number

  @institutions.State('failedInstitutions') failedInstitutions
  @institutions.State('institution') institution
  @institutions.Getter('hometaxStatus') hometaxStatus
  @institutions.Getter('giroStatus') giroStatus
  @institutions.Getter('bankStatus') bankStatus
  @institutions.Getter('eiStatus') eiStatus
  @institutions.Action('getEachInstitution') getEachInstitution
  @institutions.Action('getFailedInstitutions') getFailedInstitutions
  @institutions.Action('updateInstitution') updateInstitution
  @institutions.Mutation('clearFailed') clearFailed
  @layout.Mutation('updateError') updateError
  @layout.Mutation('updateToast') updateToast
  @biz.State('isCorporate') isCorporate
  @workflows.Action('getWorkflowStatus') getWorkflowStatus
  @workflows.State('loadingWorkflowStatus') loadingWorkflowStatus
  @workflows.Mutation('clear') clearWorkflows
  @gtm.Action('logEventWithGroups') logEventWithGroups: (payload: LogEventWidthGroupsPayload) => void

  loading: boolean = true
  triggerWorkflowCode: string = ''

  get type(): string {
    const {name} = this
    if(['hometax', 'giro', 'popbill', 'ei'].indexOf(name) > -1) return name
    return 'bank'
  }

  get title(): string {
    const {name, type} = this
    if(type !== 'bank') {
      return `${this.ts(`institution.${name}`)}`
    }
    return `${this.ts(`institution.${name}`)}${this.ts('bank')}`
  }

  created() {
    this.triggerWorkflowCode = enablingInstitutionWorkflowCodes[this.type]
    this.initData()
  }

  async initData() {
    this.clearFailed()
    const {status} = await this.getEachCert()
    if(status === 'success') {
      this.onClickBackward()
    } else {
      this.loadFailedReason()
    }
  }

  onClickBackward() {
    this.$router
      .replace({name: 'cert-center'})
      .catch((err) => err)
  }

  async onReEnabling() {
    this.logEventWithGroups({
      eventType: 'click',
      eventProperties: {
        'target': 'footer_retry_intergration',
        'page_name': 'cert_failed_reason',
      }
    })
    const {workflow} = await this.reEnabling()
    if(workflow) {
      this.triggerWorkflow(workflow)
    }
  }

  reEnabling() {
    this.loading = true
    const {type, name} = this
    return this.updateInstitution({type, name})
      .then((response) => {
        this.loading = false
        this.onClickBackward()
        return response.data || {}
      })
      .catch((error) => {
        this.loading = false
        const {status} = error.response || {}
        if(status === 409) {
          this.updateToast({
            id: 'update-institution',
            message: '다른작업을 처리중입니다. 잠시 후 다시 요청해주세요.',
          })
        } else {
          this.updateError({
            id: 'update-institution',
            message: `재${this.ts('enabling')}에 실패하였습니다.`,
          })
        }
        throw error
      })
  }

  triggerWorkflow(workflow) {
    if(this.loadingWorkflowStatus === 'loading') return
    this.clearWorkflows()
    this.getWorkflowStatus({
      id: workflow
    })
      .then(() => {
        this.updateToast({
          id: 'success-trigger-workflow',
          message: '연동된 기관의 정보를 모두 불러왔습니다.',
        })
      })
      .catch((err) => {
        this.updateError({
          id: 'update-institution',
          message: '정보를 불러오는데 실패하였습니다.',
        })
        throw err
      })
  }

  loadFailedReason() {
    this.loading = true
    const {type, name} = this
    this.getFailedInstitutions({type, name})
      .then(() => {
        this.loading = false
      })
      .catch((error) => {
        this.updateError({
          id: 'get-failed-reason',
          message: `${this.ts('enabling')}된 기관의 실패사유를 불러오는데 실패하였습니다.`,
        })
        throw error
      })
  }

  getEachCert() {
    const {type, name} = this
    const code = type === 'bank' ? name : null
    return this.getEachInstitution({type, code})
      .catch((error) => {
        this.updateError({
          id: 'get-each-cert',
          message: `${this.ts('enabling')}된 기관의 정보를 불러오는데 실패하였습니다.`,
        })
        throw error
      })
  }
}
